module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "套餐名称"
    }
  }, [(!_vm.isView) ? _c('el-input', {
    attrs: {
      "placeholder": "请输入套餐名称(必填)"
    },
    model: {
      value: (_vm.Form.ProName),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProName", $$v)
      },
      expression: "Form.ProName"
    }
  }) : _c('span', {
    staticClass: "viewspan"
  }, [_vm._v(_vm._s(_vm.Form.ProName))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "套餐简称"
    }
  }, [(!_vm.isView) ? _c('el-input', {
    attrs: {
      "placeholder": "请输入套餐简称(必填)"
    },
    model: {
      value: (_vm.Form.ProNick),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProNick", $$v)
      },
      expression: "Form.ProNick"
    }
  }) : _c('span', {
    staticClass: "viewspan"
  }, [_vm._v(_vm._s(_vm.Form.ProNick))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "套餐编号"
    }
  }, [(!_vm.isView) ? _c('el-input', {
    attrs: {
      "placeholder": "请输入套餐编号(必填)"
    },
    model: {
      value: (_vm.Form.ProCode),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProCode", $$v)
      },
      expression: "Form.ProCode"
    }
  }) : _c('span', {
    staticClass: "viewspan"
  }, [_vm._v(_vm._s(_vm.Form.ProCode))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置套餐"
    }
  }, [
    [_c('div', {
      staticStyle: {
        "border": "1px solid rgba(89, 89, 89, 0.24)",
        "margin-top": "30px",
        "width": "500px",
        "padding": "10px",
        "border-radius": "8px"
      }
    }, [_vm._l((_vm.PackageItem), function(item, index) {
      return [_c('el-row', [_c('el-col', {
        staticStyle: {
          "font-weight": "bold"
        },
        attrs: {
          "span": 4
        }
      }, [_vm._v("单品" + _vm._s(index + 1))]), _vm._v(" "), _c('el-col', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.isView),
          expression: "!isView"
        }],
        attrs: {
          "span": 4
        }
      }, [_c('el-button', {
        on: {
          "click": function($event) {
            _vm.ProductShow(index)
          }
        }
      }, [_vm._v("选择单品")])], 1)], 1), _vm._v(" "), _c('el-row', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.PackageItem[index].ProId),
          expression: "PackageItem[index].ProId"
        }],
        staticStyle: {
          "margin": "10px 0"
        }
      }, [_c('el-col', {
        attrs: {
          "span": 11
        }
      }, [_vm._v(_vm._s(item.ProName))]), _vm._v(" "), _c('el-col', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.isView),
          expression: "!isView"
        }],
        attrs: {
          "span": 9
        }
      }, [_c('el-input-number', {
        attrs: {
          "min": 0
        },
        model: {
          value: (item.ProNum),
          callback: function($$v) {
            _vm.$set(item, "ProNum", $$v)
          },
          expression: "item.ProNum"
        }
      })], 1), _vm._v(" "), _c('el-col', {
        staticStyle: {
          "margin-left": "2px"
        },
        attrs: {
          "span": 3
        }
      }, [_c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.isView),
          expression: "isView"
        }]
      }, [_vm._v(_vm._s(item.ProNum))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(item.ProUnit) + ")")])])], 1)]
    }), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "display": "flex",
        "justify-content": "center",
        "margin-top": "20px"
      }
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isView),
        expression: "!isView"
      }],
      attrs: {
        "icon": "plus"
      },
      on: {
        "click": _vm.addProduct
      }
    }, [_vm._v("添加单品")])], 1)], 2)]
  ], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货仓库类型",
      "required": ""
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.Form.StockType),
      callback: function($$v) {
        _vm.$set(_vm.Form, "StockType", $$v)
      },
      expression: "Form.StockType"
    }
  }, _vm._l((_vm.StockTypeNames), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.id,
        "label": option.name
      }
    })
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(_vm._s(_vm.Form.StockTypeName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "自然单位"
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isView),
      expression: "!isView"
    }],
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.activeNaturalId),
      callback: function($$v) {
        _vm.activeNaturalId = $$v
      },
      expression: "activeNaturalId"
    }
  }, _vm._l((_vm.naturalUnitsList), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isView),
      expression: "isView"
    }],
    staticClass: "viewspan"
  }, [_vm._v(_vm._s(_vm.Form.ProNaturalUnit))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isView),
      expression: "!isView"
    }],
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.UnitDialog(6)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售单位"
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isView),
      expression: "!isView"
    }],
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.activeSaleId),
      callback: function($$v) {
        _vm.activeSaleId = $$v
      },
      expression: "activeSaleId"
    }
  }, _vm._l((_vm.saleUnitsList), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isView),
      expression: "isView"
    }],
    staticClass: "viewspan"
  }, [_vm._v(_vm._s(_vm.Form.ProSaleUnit))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isView),
      expression: "!isView"
    }],
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.UnitDialog(7)
      }
    }
  })], 1), _vm._v(" "), (!_vm.isView) ? _c('el-form-item', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "label": "比例"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.Form.ProProportion1),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProProportion1", $$v)
      },
      expression: "Form.ProProportion1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ProNaturalUnit),
      expression: "Form.ProNaturalUnit"
    }],
    staticStyle: {
      "margin-left": "2px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isView),
      expression: "!isView"
    }]
  }, [_vm._v("(" + _vm._s(_vm.Form.ProNaturalUnit) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("等于")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.Form.ProProportion2),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProProportion2", $$v)
      },
      expression: "Form.ProProportion2"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ProSaleUnit),
      expression: "Form.ProSaleUnit"
    }],
    staticStyle: {
      "margin-left": "2px"
    },
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("(" + _vm._s(_vm.Form.ProSaleUnit) + ")")])])], 1)], 1) : _c('el-form-item', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "label": "比例"
    }
  }, [_c('el-row', {
    staticClass: "viewspan"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_vm._v(_vm._s(_vm.Form.ProProportion1) + "(" + _vm._s(_vm.Form.ProNaturalUnit) + ")")]), _vm._v(" 等于\n                    "), _c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.Form.ProProportion2) + "(" + _vm._s(_vm.Form.ProSaleUnit) + ")")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "原价(必填)"
    },
    model: {
      value: (_vm.Form.Price),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Price", $$v)
      },
      expression: "Form.Price"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "span": 2
    }
  }, [_vm._v("元")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(" " + _vm._s(_vm.Form.Price))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售价"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "placeholder": "销售价(必填)"
    },
    model: {
      value: (_vm.Form.SalePrice),
      callback: function($$v) {
        _vm.$set(_vm.Form, "SalePrice", $$v)
      },
      expression: "Form.SalePrice"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isEdit),
      expression: "this.isEdit"
    }],
    attrs: {
      "span": 2
    }
  }, [_vm._v("元")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isEdit),
      expression: "!this.isEdit"
    }],
    staticClass: "spanitem"
  }, [_vm._v(" " + _vm._s(_vm.Form.SalePrice))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "width": "100px"
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isView),
      expression: "!isView"
    }],
    attrs: {
      "type": "textarea",
      "placeholder": "请输入备注(选填)"
    },
    model: {
      value: (_vm.Form.ProRemark),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ProRemark", $$v)
      },
      expression: "Form.ProRemark"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isView),
      expression: "isView"
    }],
    staticClass: "viewspan"
  }, [(_vm.Form.ProRemark != undefined && _vm.Form.ProRemark != '') ? _c('span', [_vm._v(_vm._s(_vm.Form.ProRemark))]) : _c('span', [_vm._v("--")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isView),
      expression: "!isView"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isView),
      expression: "isView"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pathBack
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTable.title,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "close": function($event) {
        _vm.dialogClosed(1)
      }
    },
    model: {
      value: (_vm.dialog.UnitShow),
      callback: function($$v) {
        _vm.$set(_vm.dialog, "UnitShow", $$v)
      },
      expression: "dialog.UnitShow"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dialogTable.data
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ParmName",
      "label": _vm.dialogTable.label,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "delete",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.delTable(scope.$index, scope.row, _vm.dialogTable.type)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialogContent),
      callback: function($$v) {
        _vm.dialogContent = $$v
      },
      expression: "dialogContent"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addDialog(_vm.dialogTable.type)
      }
    }
  }, [_vm._v("添 加")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择单品",
      "size": "small",
      "close-on-click-modal": false
    },
    on: {
      "close": function($event) {
        _vm.dialogClosed(2)
      }
    },
    model: {
      value: (_vm.dialog.ProShow),
      callback: function($$v) {
        _vm.$set(_vm.dialog, "ProShow", $$v)
      },
      expression: "dialog.ProShow"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单品编号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入单品编号"
    },
    model: {
      value: (_vm.query.ProId),
      callback: function($$v) {
        _vm.$set(_vm.query, "ProId", $$v)
      },
      expression: "query.ProId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入名称"
    },
    model: {
      value: (_vm.query.ProName),
      callback: function($$v) {
        _vm.$set(_vm.query, "ProName", $$v)
      },
      expression: "query.ProName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.query.ProClass),
      callback: function($$v) {
        _vm.$set(_vm.query, "ProClass", $$v)
      },
      expression: "query.ProClass"
    }
  }, _vm._l((_vm.ProductClass), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Value,
        "label": option.Key
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "种类"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.query.ProAttr),
      callback: function($$v) {
        _vm.$set(_vm.query, "ProAttr", $$v)
      },
      expression: "query.ProAttr"
    }
  }, _vm._l((_vm.Category), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getProList
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), (!_vm.loading2) ? _c('el-row', [(_vm.ProductList.length > 0) ? _c('el-row', _vm._l((_vm.ProductList), function(item) {
    return _c('div', {
      staticStyle: {
        "width": "19%",
        "display": "inline-block",
        "text-align": "center",
        "margin-top": "20px",
        "overflow": "hidden"
      }
    }, [_c('el-radio', {
      staticClass: "radio",
      staticStyle: {
        "float": "left"
      },
      attrs: {
        "label": item.ProductId
      },
      model: {
        value: (_vm.activeProductId),
        callback: function($$v) {
          _vm.activeProductId = $$v
        },
        expression: "activeProductId"
      }
    }, [_vm._v(_vm._s(item.ProName))])], 1)
  })) : _c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('span', [_vm._v("暂无数据")])])], 1)], 1) : _c('el-row', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("正在加载数据中.....")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "50px",
      "display": "flex",
      "justify-content": "flex-end",
      "margin-bottom": "-10px"
    }
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ProductList.length > 0),
      expression: "ProductList.length>0"
    }],
    attrs: {
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.ProductSure()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f565c52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/productInformation/addPackage.vue
// module id = 1520
// module chunks = 1